import { useRequest } from 'features/request/useRequest';
import { graphql } from 'gql';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const uerIsValidActKC3DateGql = graphql(`
    query uerIsValidActKC3Date($actKC3Id: Long!, $date: Date!) {
        uerIsValidActKC3Date(actKC3Id: $actKC3Id, date: $date) {
            buttonText
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

const requestId = 'uerIsValidActKC3Date';

export const useIsValidActKC3Date = ({ date, actKC3Id }: { date: Date; actKC3Id?: number }) => {
    const dispatch = useDispatch();

    const [dataUerIsValidActKC3Date, statusIsValidActKC3Date, , requestIsValidActKC3Date] = useRequest({
        requestId,
        query: uerIsValidActKC3DateGql,
        withEffect: false,
    });

    useEffect(() => {
        if (date && actKC3Id) {
            dispatch(requestIsValidActKC3Date({ actKC3Id, date }));
        }
    }, [actKC3Id, date, dispatch, requestIsValidActKC3Date]);

    return {
        dataUerIsValidActKC3Date: dataUerIsValidActKC3Date?.uerIsValidActKC3Date,
        statusIsValidActKC3Date,
    };
};
